import React from 'react';

import { Skeleton } from '../../Skeleton';
import * as s from './RealtorRatingTableTbody.css';

/**
 * Скелетон тела таблицы рейтинга риелторов
 */
export const RealtorRatingTableTbodySkeleton = () => (
  <tbody>
    {[...Array(9)].map((_, trIndex) => (
      <tr key={`tr-${trIndex}`} data-tr={trIndex}>
        {[...Array(9)].map((_, tdIndex) => (
          <td key={`td-${trIndex}-${tdIndex}`} className={s['td']} data-td={tdIndex}>
            <Skeleton height={20} />
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);
